export enum AbsenceType {
  REMAINED_CARE_A188,
  CARE_A188_DURATION,
  LEAVE_DURATION,
  OVERDUE_LEAVE,
  REMAINED_LEAVE,
  REMAINED_OVERDUE_LEAVE,
  LEAVE_ON_DEMAND_DURATION,
  REMAINED_LEAVE_ON_DEMAND,
}
